import { Injectable } from '@angular/core';
import { BackgroundMode } from '@ionic-native/background-mode';
import { LocalNotifications } from '@ionic-native/local-notifications';
import { Platform } from 'ionic-angular';
import { Observable } from 'rxjs/Observable';

import { tableNames, propertyNames, globalDefines } from '../../app/app.constants';
import { GlobalVars } from '../../app/app.environment';
import { Timetable } from '../../models/timetable';
import { FirebaseProvider } from '../firebase/firebase';
import { TimetableProvider } from '../timetable/timetable';
import { UserProvider } from '../user/user';


@Injectable()
export class NotificationProvider {

  private notificationAlreadyReceived = false;
  private notifications;
  
  constructor(
    public backgroundMode: BackgroundMode, 
    public localNotifications: LocalNotifications,
    public platform: Platform,
    
    public firebaseService: FirebaseProvider,
    public globalVars: GlobalVars,
    public timetableProvider: TimetableProvider,
    public userProvider: UserProvider,
  ) {}

  getCheckReminder(userId?: string): Observable<boolean> {
    return this.firebaseService.propertyValue(this.getBaseRoot() + (userId || this.globalVars.user.key) + '/' + propertyNames.Notification);
  }

  getCheckReminderOnce(userId?: string): Observable<boolean> {
    return this.firebaseService.propertyValueOnce(this.getBaseRoot() + (userId || this.globalVars.user.key) + '/' + propertyNames.Notification);
  }

  setCheckReminder(checkReminder: boolean, userId?: string) {
    return this.firebaseService.set(this.getBaseRoot() + (userId || this.globalVars.user.key), propertyNames.Notification, checkReminder);
  }

  scheduleNotifications() {
    if(this.platform.is('cordova')) {
      this.getCheckReminderOnce().subscribe(enabled => {
        if(enabled) {
          this.userProvider.getLastTimetableOnce().subscribe(timetableId => {
            this.timetableProvider.getTimetableOnce(timetableId.value).subscribe(timetable => {
              this.prepareNotifications(timetable);
            })
          })
        }
      })
    }
  }

  private prepareNotifications(timetable: Timetable) {
    this.platform.ready().then(() => {
                
      this.backgroundMode.on('activate').subscribe(() => {
        if(this.notificationAlreadyReceived === false) {

          this.notifications = [];

          let date = new Date();
          let checkDate = new Date();

          // Iterar per dies
          for(let j = 0; j < 4; j++) {

            let checkDateAfter = new Date(checkDate);

            // Iterar per hores de fitxatge
            for(let i = 0; i < timetable.checks.length; i++) {
              checkDateAfter = new Date(checkDate);
          
              let hourString = timetable.checks[i].hour.split(':');    
              checkDateAfter.setHours(Number(hourString[0]), Number(hourString[1]), 0, 0);

              let sendingDateAfter = new Date(checkDateAfter)
              sendingDateAfter.setTime(sendingDateAfter.getTime() - globalDefines.notificationDelay * 60 * 1000);
              
              if(date < checkDateAfter) this.prepareNotificationData(sendingDateAfter, checkDateAfter);
            }    

            checkDateAfter.setDate(checkDateAfter.getDate()+1);
            checkDate = checkDateAfter;
          }

          // Programar només la 1a notificació (totes en un futur) *************
          this.localNotifications.schedule(this.notifications[0]);
        }
      });
      this.backgroundMode.enable();
    })
  }

  private prepareNotificationData(sendingDate: Date, checkDate: Date) {
    console.log('Sending notification')
    console.log(sendingDate.toLocaleString());
    console.log(checkDate.toLocaleString());
    
    if(checkDate.getDay() != 0 && checkDate.getDay() != 6) {
      this.notifications.push({
        text: 'Recuerde que debe fichar a las ' + checkDate.toLocaleTimeString() + '.',
        at: sendingDate
      })
    }
  }

  /**
   * Arrel base dins la base de dades.
   */
  private getBaseRoot(): string {
    return tableNames.Repo + '/' + this.globalVars.user.repo + '/' + tableNames.User + '/';
  }
  
}



// WEBPACK FOOTER //
// ./src/providers/notification/notification.ts